import { jsx as _jsx } from "react/jsx-runtime";
import DatePicker from "antd/lib/date-picker";
import "antd/lib/date-picker/style/index.js";
import { DatePickerProps } from "antd";
import { formatMomentDate } from './helpers';
import { DATE_FORMATS } from '$Utils';
const HVDatePicker = ({ value, ...props }) => {
    return (_jsx(DatePicker, { ...props, format: DATE_FORMATS, 
        // AntD DatePicker and RangePicker in v4.20.3 expects/returns a MomentJS object.
        // If and when we upgrade AntD, we can switch this to DayJS, which is what the newer versions expect.
        value: formatMomentDate(value) }));
};
export default HVDatePicker;
